import { Checkbox, FormControlLabel } from '@mui/material';
import { ButtonForm, CustomTextField } from 'Components/Form/styles';
import { Column, Row } from 'Components/Grid';
import { Controller } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const FormUsersGroup = ({ handleComplete, register, control, handleSubmit, errors }) => {
  const { t } = useTranslation(['user', 'common']);
  // const theme = useTheme()
  const navigate = useNavigate();
  const onSubmit = () => {
    handleComplete();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Row justifyContent="center" alignItems="center">
        <Column xs={12} sm={8} md={9} className="d-flex">
          <div data-tour="group-name" style={{ width: '100%' }}>
            <CustomTextField
              {...register('name', { required: t('user:groups.form.validation.nameRequired') })}
              label={t('user:groups.form.name')}
              autoFocus
              error={errors?.name ? true : false}
              sx={{ minHeight: '48px', margin: '0 auto 24px', width: '100%' }}
              helperText={errors?.name ? errors.name.message : null}
              InputLabelProps={{ shrink: true }}
            />
          </div>
        </Column>
        <Column xs={12} sm={4} md={3} className="d-flex" style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
          <div data-tour="group-active">
            <Controller
              control={control}
              name="active"
              render={({ field: { onChange, value } }) => (
                <FormControlLabel
                  value={value}
                  control={<Checkbox checked={value} onChange={onChange} name="active" />}
                  label={t('user:groups.form.active')}
                  sx={{ marginLeft: 0, marginBottom: '16px' }}
                />
              )}
            />
          </div>
        </Column>
      </Row>
      <Row justifyContent="end" alignItems="center">
        <Column xs={4} md={3} className="d-flex" style={{ gap: '8px', justifyContent: 'flex-end' }}>
          <div data-tour="form-actions" style={{ display: 'flex', gap: '8px', width: '100%', justifyContent: 'flex-end' }}>
            <ButtonForm secondary id="cancel" label={t('common:buttons.cancel')} onClick={() => navigate('/users-groups')}></ButtonForm>
            <ButtonForm label={t('common:buttons.save')} type="submit" />
          </div>
        </Column>
      </Row>
    </form>
  );
};
